module.exports = __webpack_public_path__ + "img/2.c1e4af41.png";